import { makeStyles, tokens } from "@fluentui/react-components";
export const useSensitivityIconStyles = makeStyles({
    sensitivityIconContainer: {
        display: "inline-flex"
    },
    sensitivityIcon: {
        position: "absolute",
        color: tokens.colorNeutralForeground1
    }
});
